import React from 'react';
import { TabItem, TabText } from './styled';
import { TabVariantEnum } from '../types';

interface SearchTabProps {
  name: string;
  text: string;
  currentTabId?: number;
  tabId: number;
  switchTab?: React.Dispatch<React.SetStateAction<number>>;
  itemsCount: number;
  disabled: boolean;
  stat?: string;
  isSelected?: boolean;
  onClick?: () => void;
  variant: TabVariantEnum;
}

export const SearchTab = ({
  name,
  text,
  tabId,
  currentTabId,
  switchTab,
  itemsCount,
  disabled,
  stat,
  isSelected,
  onClick,
  variant
}: SearchTabProps) => {
  const onHandle = switchTab || onClick;

  const handleClick = () => {
    if (disabled) return;
    onHandle?.(tabId);
  };

  const isTabSelected = tabId === currentTabId || isSelected;

  return (
    <TabItem
      $isSelected={!!isTabSelected}
      id={`quick-links-tab-${name}`}
      onClick={handleClick}
      onKeyPress={handleClick}
      role="tab"
      disabled={disabled}
      data-stat={stat}
      variant={variant}
    >
      <TabText tag="body_2" $isSelected={!!isTabSelected} $variant={variant}>
        {`${text}${itemsCount ? ` (${itemsCount})` : ''}`}
      </TabText>
    </TabItem>
  );
};
